/**
 * 组合 bartender 模版的打印数据
 * @param data 原始数据列表
 * @param fields 模版配置
 */
export function bartenderPrinterData (data, fields) {
    const result = []

    for (const item of data) {
        const subItem = {}

        for (const field of fields) {
            let value = field.value

            if (field.modelFieldPath) {
                try {
                    // eslint-disable-next-line no-eval
                    value = eval('item.' + field.modelFieldPath)
                } catch (e) {
                    console.log(e, item)
                }
            }
            subItem[field.code] = value
        }
        result.push(subItem)
    }

    return result
}



// WEBPACK FOOTER //
// ./src/comp/lib/printData.js